import { createActionCard } from '@/presentation/prefabs/actor/actionCard/actionCard.js';
import { getActionCardsInHand } from "@/presentation/helpers/selectors.js";
import { ACTOR_TAGS } from "@/presentation/helpers/actorTags.js";
import { calculateActionCardPosition } from "@/presentation/renderers/gameSceneRendererUtils.js";

// Draw the active player's hand at the bottom of the screen
async function drawCardFullHand(k, activePlayer) {
    k.destroyAll(ACTOR_TAGS.ACTION_CARD);

    const spawnPromises = activePlayer.hand.map((cardInstance, index) => {
        const position = calculateActionCardPosition(k, index, activePlayer.hand.length);
        k.play("card_flip_2", { volume: 0.2, speed: 1.2 });

        return createActionCard(k, cardInstance, index, position);
    });

    await Promise.all(spawnPromises);
}

// Draw a single card
async function drawCard(k, activePlayer, cardInstance) {
    const playerHand = getActionCardsInHand(k);

    // Move existing cards
    const movePromises = playerHand.map((cardActor, index) => {
        const newTargetX = calculateActionCardPosition(k, index, activePlayer.hand.length).x;
        k.play("card_flip_1", { volume: 0.3 });

        return k.tween(
            cardActor.pos.x,
            newTargetX,
            0.3,
            (v) => cardActor.pos = k.vec2(v, cardActor.pos.y),
            k.easings.easeOutQuad
        );
    });

    // Create new card
    const newIndex = activePlayer.hand.length - 1;
    const newTargetPos = calculateActionCardPosition(k, newIndex, activePlayer.hand.length);

    await Promise.all([
        ...movePromises,
        createActionCard(k, cardInstance, newIndex, newTargetPos)
    ]);
}

// Update visual on action card when selected
function updateCardSelectionVisuals(k, selectedIndex) {
    const playerHand = getActionCardsInHand(k);

    playerHand.forEach(card => {
        const isSelected = (card.handIndex === selectedIndex);
        card.setSelected(isSelected);
    });
}

export {
    drawCardFullHand,
    drawCard,
    updateCardSelectionVisuals,
    calculateActionCardPosition
}